import './style.css';
import Draw from 'ol/interaction/Draw';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { fromLonLat } from 'ol/proj';
import ScaleLineControl from 'ol/control/ScaleLine';
import ZoomControl from 'ol/control/Zoom';
import MousePositionControl from 'ol/control/MousePosition';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import {Circle as CircleStyle, Icon, Style, Fill, Stroke, Text } from 'ol/style';
import Overlay from 'ol/Overlay';
import XYZ from 'ol/source/XYZ';
import { toLonLat } from 'ol/proj';
import { toStringHDMS } from 'ol/coordinate';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import {LineString, Polygon} from 'ol/geom.js';
import {getArea, getLength} from 'ol/sphere.js';
import {circular} from 'ol/geom/Polygon';
import Control from 'ol/control/Control';
import 'ol-ext/dist/ol-ext.css'
import SearchFeature from 'ol-ext/control/SearchFeature';
import {unByKey} from 'ol/Observable.js';
import ImageWMS from 'ol/source/ImageWMS.js';
import {Image as ImageLayer} from 'ol/layer';

import { jsPDF } from 'jspdf';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

proj4.defs('EPSG:3765',
  '+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 ' +
  '+x_0=500000 +y_0=0 +ellps=GRS80 ' +
  '+towgs84=0,0,0,0,0,0,0 ' +
  '+units=m +no_defs');
register(proj4);

/**
 * Elements that make up the popup.
 */
const container = document.getElementById('popup');
const content = document.getElementById('popup-content');
const closer = document.getElementById('popup-closer');

const wmsLayer = new TileLayer({
  source: new TileWMS({
    url: 'https://geoportal.dgu.hr/services/inspire/orthophoto_2021_2022/wms',
	params: {
      "LAYERS": "OI.OrthoimageCoverage",
      "TILED": "true",
      "VERSION": "1.3.0",
    },
    serverType: 'geoserver',
  }),
  visible: true // Dodajte vidljivost sloja
});

/*
const wmsLayer = new ImageLayer({
    source: new ImageWMS({
      url: 'https://geoportal.dgu.hr/services/inspire/orthophoto_2021_2022/wms',
      params: {
      "LAYERS": "OI.OrthoimageCoverage",
      "TILED": "true",
      "VERSION": "1.3.0",
    },
      ratio: 1,
      serverType: 'geoserver',
    }),
  });
*/

const wmsLayerCheckbox = document.getElementById('wms-layer-checkbox');

wmsLayerCheckbox.addEventListener('change', function() {
  wmsLayer.setVisible(wmsLayerCheckbox.checked);
});

const map = new Map({
  target: 'map',
  view: new View({
    projection: 'EPSG:3765',
    center: fromLonLat([16.33, 43.81], 'EPSG:3765'),
    zoom: 12.4,
  }),
  layers: [wmsLayer],
  controls: [
    new ScaleLineControl({
      units: 'metric',
      bar: true,
      steps: 2,
      text: true,
      minWidth: 100
    }),
    new ZoomControl(),
    new MousePositionControl({
      coordinateFormat: function(coord) {
        return 'HTRS96/TM ' + `${coord[0].toFixed(2)}, ${coord[1].toFixed(2)}`;
      },
      projection: 'EPSG:3765', 
      className: 'custom-mouse-position',
      target: document.getElementById('mouse-position')
    })
  ],
});

// Location
const source = new VectorSource();
const llayer = new VectorLayer({
  source: source,
});
map.addLayer(llayer);

const lokacija = document.getElementById('lokacija');
lokacija.addEventListener('click', function () {
  // Get the user's location
  navigator.geolocation.getCurrentPosition(function(position) {
    // Clear the source
    source.clear(true);

    // Add the user's location to the source
    const coords = [position.coords.longitude, position.coords.latitude];
    const accuracy = circular(coords, position.coords.accuracy);
    source.addFeatures([
      new Feature(
        accuracy.transform('EPSG:4326', map.getView().getProjection())
      ),
      new Feature(new Point(fromLonLat(coords, 'EPSG:3765'))),
    ]);

    // Fit the map to the user's location
    map.getView().fit(source.getExtent(), {
      maxZoom: 18,
      duration: 500,
    });
  }, function(error) {
    // Handle the error
    console.log(error);
  });
});

map.addControl(
  new Control({
    element: lokacija,
  })
);

//export u pdf
const dims = {
  a0: [1189, 841],
  a1: [841, 594],
  a2: [594, 420],
  a3: [420, 297],
  a4: [297, 210],
  a5: [210, 148],
};

const exportButton = document.getElementById('export-pdf');
const printArea = document.querySelector('.print-area');
var dsize = 0;

exportButton.addEventListener(
  'click',
  function () {
    exportButton.disabled = true;
    document.body.style.cursor = 'progress';

    const format = document.getElementById('format').value;
    const resolution = document.getElementById('resolution').value;
    const dim = dims[format];
    const width = Math.round((dim[0] * resolution) / 25.4);
    const height = Math.round((dim[1] * resolution) / 25.4);
    const size1 = map.getSize();
	var size = map.getSize();
	  if(size[0]>size[1]){
		dsize = size[1]
	  } else{
	  	dsize = size[0]
	  };
	dsize = Math.round((Math.round(dsize/210))/2);
	size = [dsize*297,dsize*210]
    const viewResolution = map.getView().getResolution();
    map.once('rendercomplete', function () {
      const mapCanvas = document.createElement('canvas');
      mapCanvas.width = width;
      mapCanvas.height = height;
      const mapContext = mapCanvas.getContext('2d');
	  mapContext.fillStyle = 'white';
	  mapContext.fillRect(0, 0, width, height);
      Array.prototype.forEach.call(
        document.querySelectorAll('.ol-layer canvas'),
        function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            // Get the transform parameters from the style's transform matrix
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix
            );
            mapContext.drawImage(canvas, 0, 0);
          }
        }
      );
      mapContext.globalAlpha = 1;
      mapContext.setTransform(1, 0, 0, 1, 0, 0);
      const pdf = new jsPDF('landscape', undefined, format);
      pdf.addImage(
        mapCanvas.toDataURL('image/jpeg'),
        'JPEG',
        0,
        0,
        dim[0],
        dim[1]
      );
      pdf.save('map.pdf');
      // Reset original map size
      map.setSize(size1);
      map.getView().setResolution(viewResolution);
      exportButton.disabled = false;
      document.body.style.cursor = 'auto';
    });

    // Set print size
    const printSize = [width, height];
    map.setSize(printSize);
    const scaling = Math.min(width / size[0], height / size[1]);
    map.getView().setResolution(viewResolution / scaling);
  },
  false
);

// Funkcija za stvaranje vektorskog sloja i povezivanje s GeoJSON podacima
function createVectorLayer(source, dataUrl, checkboxId) {
  const vectorLayer = new VectorLayer({
    source: source,
  });

  fetch(dataUrl)
    .then(response => response.json())
    .then(data => {
      source.addFeatures(source.getFormat().readFeatures(data));
    });

  const checkbox = document.getElementById(checkboxId);
  checkbox.addEventListener('change', () => {
    vectorLayer.setVisible(checkbox.checked);
  });

  return vectorLayer;
}

// Kreiranje vektorskog sloja za prvi sloj (granice_opcine)
const vectorSource1 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer1 = createVectorLayer(vectorSource1, './data/Granice_opcine.geojson', 'layer1-checkbox');
vectorLayer1.setStyle(new Style({
  fill: new Fill({
    color: 'rgba(0, 0, 0, 0)',
  }),
  stroke: new Stroke({
    color: 'red',
    width: 3,
  }),
}));
map.addLayer(vectorLayer1);

//kreiranje stila labela i vektorskog sloja
const borderStyle = new Style({
  fill: new Fill({
    color: 'rgba(0, 0, 0, 0)',
  }),
  stroke: new Stroke({
    color: 'orange',
    width: 1.5,
  }),
});

const labelStyle = new Style({
  text: new Text({
    font: '18px Calibri,sans-serif',
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 1.5,
    }),
  }),
});

// Kreiranje vektorskog sloja za drugi sloj (granice_naselja)
const vectorSource2 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer2 = createVectorLayer(vectorSource2, './data/Granice_naselja.geojson', 'layer2-checkbox');

// Postavljanje funkcije za stil vektorskog sloja
vectorLayer2.setStyle(function (feature) {
  const label = feature.get('NAZIV NASELJA');
  labelStyle.getText().setText(label);
  return [borderStyle, labelStyle];
});

map.addLayer(vectorLayer2);

// Kreiranje vektorskog sloja za treći sloj (Javna_parkiralista)
const vectorSource3 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer3 = createVectorLayer(vectorSource3, './data/Javna_parkiralista.geojson', 'layer3-checkbox');
vectorLayer3.setStyle(new Style({
  fill: new Fill({
    color: 'rgba(0, 0, 0, 0.1)',
  }),
  stroke: new Stroke({
    color: 'black',
    width: 0.5,
  }),
}));
map.addLayer(vectorLayer3);

// Kreiranje vektorskog sloja za četvrti sloj (Javne_zelene_povrsine)
const vectorSource4 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer4 = createVectorLayer(vectorSource4, './data/Javne_zelene_povrsine.geojson', 'layer4-checkbox');
vectorLayer4.setStyle(new Style({
  fill: new Fill({
    color: 'rgba(218, 255, 111, 0.4)',
  }),
  stroke: new Stroke({
    color: 'black',
    width: 0.5,
  }),
}));
map.addLayer(vectorLayer4);

//kreiranje stila labela i vektorskog sloja za nerazvrstane ceste
const borderStyle1 = new Style({
  stroke: new Stroke({
    color: '#dadada',
    width: 2,
  }),
});

const labelStyle1 = new Style({
  text: new Text({
    font: '15px Calibri,sans-serif',
	placement: 'line',
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 2,
    }),
  }),
});

// Kreiranje vektorskog sloja za peti sloj (Nerazvrstane ceste)
const vectorSource5 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer5 = createVectorLayer(vectorSource5, './data/Nerazvrstane_ceste.geojson', 'layer5-checkbox');

// Postavljanje funkcije za stil vektorskog sloja
vectorLayer5.setStyle(function (feature) {
  const currentZoom = map.getView().getZoom();
  const label1 = feature.get('OZNAKA I NAZIV NERAZVRSTANE CESTE');

  if (currentZoom >= 15) {
    labelStyle1.getText().setText(label1);
    return [borderStyle1, labelStyle1];
  } else {
    labelStyle1.getText().setText(''); // Prazan tekst će sakriti oznaku na manjim razinama zooma
    return [borderStyle1];
  }
});

map.addLayer(vectorLayer5);


//kreiranje stila labela i vektorskog sloja za Javne ceste
const borderStyle2 = new Style({
  stroke: new Stroke({
    color: 'magenta',
    width: 4,
  }),
});

const labelStyle2 = new Style({
  text: new Text({
    font: '15px Calibri,sans-serif',
	placement: 'line',
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 2,
    }),
  }),
});

const borderStyle3 = new Style({
  stroke: new Stroke({
    color: 'yellow',
    width: 3,
  }),
});

const labelStyle3 = new Style({
  text: new Text({
    font: '15px Calibri,sans-serif',
	placement: 'line',
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 2,
    }),
  }),
});

const borderStyle4 = new Style({
  stroke: new Stroke({
    color: 'blue',
    width: 2,
  }),
});

const labelStyle4 = new Style({
  text: new Text({
    font: '15px Calibri,sans-serif',
	placement: 'line',
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 2,
    }),
  }),
});

// Kreiranje vektorskog sloja za šesti sloj (Javne ceste)
const vectorSource6 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer6 = createVectorLayer(vectorSource6, './data/Javne_ceste.geojson', 'layer6-checkbox');

// Postavljanje funkcije za stil vektorskog sloja
vectorLayer6.setStyle(function (feature) {
  const currentZoom = map.getView().getZoom();
  const label2 = feature.get('VRSTA CESTE');
  const label3 = feature.get('OZNAKA CESTE');

  // Definirajte različite stilove koje želite primijeniti
  const styleOption1 = [borderStyle2, labelStyle2];
  const styleOption2 = [borderStyle3, labelStyle3];
  const styleOption3 = [borderStyle4, labelStyle4];
  // Dodajte još stilova prema potrebi...

  if (currentZoom >= 14) {
    if (label2 === 'Državna cesta') {
      labelStyle2.getText().setText(label3);
      return styleOption1;
    } else if (label2 === 'Županijska cesta') {
      labelStyle3.getText().setText(label3);
      return styleOption2;
    } else if (label2 === 'Lokalna cesta') {
      labelStyle4.getText().setText(label3);
      return styleOption3;
    }
	else {
      // Ako nijedan od uvjeta nije ispunjen, možete vratiti neki zadani stil
      return [borderStyle1, labelStyle1];
    }
  } else {
    // Prazan tekst će sakriti oznaku na manjim razinama zooma
    labelStyle2.getText().setText('');
    labelStyle3.getText().setText('');
	labelStyle4.getText().setText('');
  }
});

map.addLayer(vectorLayer6);

// Kreiranje vektorskog sloja za sedmi sloj (Groblja)
const vectorSource7 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer7 = createVectorLayer(vectorSource7, './data/Groblja.geojson', 'layer7-checkbox');
vectorLayer7.setStyle(new Style({
  fill: new Fill({
    color: 'rgba(133, 182, 111, 0.3)',
  }),
    stroke: new Stroke({
    color: '#000',
    width: 1,
  }),
}));
map.addLayer(vectorLayer7);

// Kreiranje vektorskog sloja za osmi sloj (Grobna_mjesta)
const vectorSource8 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer8 = createVectorLayer(vectorSource8, './data/Grobna_mjesta.geojson', 'layer8-checkbox');
vectorLayer8.setStyle(new Style({
  fill: new Fill({
    color: 'rgba(122, 83, 0, 0.3)',
  }),
    stroke: new Stroke({
    color: '#000',
    width: 0.5,
  }),
}));
map.addLayer(vectorLayer8);

// Kreiranje vektorskog sloja za deveti sloj (Autobusne_cekaonice)
const vectorSource9 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer9 = createVectorLayer(vectorSource9, './data/Autobusne_cekaonice.geojson', 'layer9-checkbox');
vectorLayer9.setStyle(new Style({
    fill: new Fill({
      color: 'rgba(7, 101, 153, 0.8)', // Prilagodite boju ispune
    }),
    stroke: new Stroke({
      color: '#fff', // Prilagodite boju obrisu
      width: 1, // Prilagodite debljinu obrisu
    }),
}));
map.addLayer(vectorLayer9);
/*
const vectorSource9 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer9 = createVectorLayer(vectorSource9, './data/Autobusne_cekaonice.geojson', 'layer9-checkbox');
vectorLayer9.setStyle(
  new Style({
    image: new Icon({
      crossOrigin: 'anonymous',
      src: 'images/bus.svg',
	  scale: 0.15,
    }),
  })
);
map.addLayer(vectorLayer9);
*/

// Kreiranje vektorskog sloja za deseti sloj (Spomen_obiljezja)
const vectorSource10 = new VectorSource({
  format: new GeoJSON(),
});
const vectorLayer10 = createVectorLayer(vectorSource10, './data/Spomen_obiljezja.geojson', 'layer10-checkbox');
vectorLayer10.setStyle(new Style({
  fill: new Fill({
    color: 'rgba(204, 0, 34, 0.5)',
  }),
    stroke: new Stroke({
    color: '#000',
    width: 0.5,
  }),
}));
map.addLayer(vectorLayer10);

//mjerenje
const msource = new VectorSource();

const mvector = new VectorLayer({
  source: msource,
  style: {
    'fill-color': 'rgba(255, 255, 255, 0.2)',
    'stroke-color': '#ffcc33',
    'stroke-width': 2,
    'circle-radius': 7,
    'circle-fill-color': '#ffcc33',
  },
});

map.addLayer(mvector);

let sketch;
let helpTooltipElement;
let helpTooltip;
let measureTooltipElement;
let measureTooltip;
const continuePolygonMsg = 'Klikni za nastavak crtanja poligona';
const continueLineMsg = 'Klikni za nastavak crtanja linije';
var mjerenje=false;

const pointerMoveHandler = function (evt) {
  if (evt.dragging) {
    return;
  }
  /** @type {string} */
  let helpMsg = 'Klikni za početak crtanja';

  if (sketch) {
    const geom = sketch.getGeometry();
    if (geom instanceof Polygon) {
      helpMsg = continuePolygonMsg;
    } else if (geom instanceof LineString) {
      helpMsg = continueLineMsg;
    }
  }

  helpTooltipElement.innerHTML = helpMsg;
  helpTooltip.setPosition(evt.coordinate);

  helpTooltipElement.classList.remove('hidden');
};

map.on('pointermove', pointerMoveHandler);

const typeSelect = document.getElementById('type');

let draw;

/**
 * Format length output.
 * @param {LineString} line The line.
 * @return {string} The formatted length.
 */
const formatLength = function (line) {
  const length = getLength(line);
  let output;
  if (length > 100) {
    output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
  } else {
    output = Math.round(length * 100) / 100 + ' ' + 'm';
  }
  return output;
};

/**
 * Format area output.
 * @param {Polygon} polygon The polygon.
 * @return {string} Formatted area.
 */
const formatArea = function (polygon) {
  const area = getArea(polygon);
  let output;
  if (area > 10000) {
    output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>';
  } else {
    output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
  }
  return output;
};

function addInteraction() {
  const type = typeSelect.value;

const geometryType = type === 'area' ? 'Polygon' : 'LineString';
  draw = new Draw({
    source: msource,
    type: geometryType,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)',
      }),
      stroke: new Stroke({
        color: 'rgba(0, 0, 0, 0.5)',
        lineDash: [10, 10],
        width: 2,
      }),
      image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0.7)',
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
      }),
    }),
  });
  map.addInteraction(draw);

  createMeasureTooltip();
  createHelpTooltip();

  let listener;
  draw.on('drawstart', function (evt) {
    // set sketch
    sketch = evt.feature;

    /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
    let tooltipCoord = evt.coordinate;

    listener = sketch.getGeometry().on('change', function (evt) {
      const geom = evt.target;
      let output;
      if (geom instanceof Polygon) {
        output = formatArea(geom);
        tooltipCoord = geom.getInteriorPoint().getCoordinates();
      } else if (geom instanceof LineString) {
        output = formatLength(geom);
        tooltipCoord = geom.getLastCoordinate();
      }
      measureTooltipElement.innerHTML = output;
      measureTooltip.setPosition(tooltipCoord);
    });
  });

  draw.on('drawend', function () {
    measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
    measureTooltip.setOffset([0, -7]);
    // unset sketch
    sketch = null;
    // unset tooltip so that a new one can be created
    measureTooltipElement = null;
    createMeasureTooltip();
    unByKey(listener);
  });
}

/**
 * Creates a new help tooltip
 */
function createHelpTooltip() {
  if (helpTooltipElement) {
    helpTooltipElement.parentNode.removeChild(helpTooltipElement);
  }
  helpTooltipElement = document.createElement('div');
  helpTooltipElement.className = 'ol-tooltip hidden';
  helpTooltip = new Overlay({
    element: helpTooltipElement,
    offset: [15, 0],
    positioning: 'center-left',
  });
  map.addOverlay(helpTooltip);
}

/**
 * Creates a new measure tooltip
 */
function createMeasureTooltip() {
  if (measureTooltipElement) {
    measureTooltipElement.parentNode.removeChild(measureTooltipElement);
  }
  measureTooltipElement = document.createElement('div');
  measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
  measureTooltip = new Overlay({
    element: measureTooltipElement,
    offset: [0, -15],
    positioning: 'bottom-center',
    stopEvent: false,
    insertFirst: false,
  });
  map.addOverlay(measureTooltip);
}

/**
 * Let user change the geometry type.
 */
typeSelect.onchange = function () {
  map.removeInteraction(draw);
  addInteraction();
};

//addInteraction(); //prvi put poziv funkcije

const measureButton = document.getElementById('measure-button');
const measureSwitcher = document.getElementById('measure-switcher');

measureButton.addEventListener('click', function() {
    if (measureSwitcher.style.display === 'none') {
      measureSwitcher.style.display = 'flex';
	  measureButton.style.backgroundColor = '#007B66';
	  mjerenje=true;
    } else {
      measureSwitcher.style.display = 'none';
	  measureButton.style.backgroundColor = 'white';
	  map.removeInteraction(draw);
      map.removeOverlay(helpTooltip);
      map.removeOverlay(measureTooltip);
	  mjerenje=false;
    }
});

closeicon.addEventListener('click', function() {
    if (measureSwitcher.style.display === 'none') {
      measureSwitcher.style.display = 'flex';
	  measureButton.style.backgroundColor = '#007B66';
	  mjerenje=true;
    } else {
      measureSwitcher.style.display = 'none';
	  measureButton.style.backgroundColor = 'white';
	  map.removeInteraction(draw);
      map.removeOverlay(helpTooltip);
      map.removeOverlay(measureTooltip);
	  mjerenje=false;
    }
});

map.addControl(
  new Control({
    element: measureButton,
  })
);

map.addControl(
  new Control({
    element: measureSwitcher,
  })
);

//crtanje
const dsource = new VectorSource({wrapX: false});

const dvector = new VectorLayer({
  source: dsource,
});

map.addLayer(dvector);

var crtanje=false;

function addInteraction1(type) {
  if (type !== 'None') {
    draw = new Draw({
      source: dsource,
      type: type,
    });
    map.addInteraction(draw);
	crtanje=true;
  }
}

function removeInteraction1() {
  if (draw) {
    map.removeInteraction(draw);
	crtanje=false;
  }
}

document.getElementById('pointBtn').addEventListener('click', function () {
  removeInteraction1();
  addInteraction1('Point');
});

document.getElementById('lineBtn').addEventListener('click', function () {
  removeInteraction1();
  addInteraction1('LineString');
});

document.getElementById('polygonBtn').addEventListener('click', function () {
  removeInteraction1();
  addInteraction1('Polygon');
});

document.getElementById('circleBtn').addEventListener('click', function () {
  removeInteraction1();
  addInteraction1('Circle');
});

document.getElementById('noneBtn').addEventListener('click', function () {
  removeInteraction1();
  map.removeInteraction(draw);
  map.removeOverlay(helpTooltip);
  map.removeOverlay(measureTooltip);
  drawSwitcher.style.display = 'none';
  drawButton.style.backgroundColor = 'white';
});

const drawButton = document.getElementById('draw-button');
const drawSwitcher = document.getElementById('drawSwitcher');

drawButton.addEventListener('click', function() {
    if (drawSwitcher.style.display === 'none') {
      drawSwitcher.style.display = 'flex';
	  drawButton.style.backgroundColor = '#007B66';
    } else {
      drawSwitcher.style.display = 'none';
	  drawButton.style.backgroundColor = 'white';
	  removeInteraction1();
    }
});

map.addControl(
  new Control({
    element: drawButton,
  })
);

map.addControl(
  new Control({
    element: drawSwitcher,
  })
);

const toggleButton = document.getElementById('toggleButton');
const layerSwitcher = document.getElementById('layerSwitcher');

toggleButton.addEventListener('click', function() {
  if (layerSwitcher.style.display === 'none') {
    layerSwitcher.style.display = 'flex'; // Prikazivanje Layer Switchera
    toggleButton.innerHTML = '&#10006;'; // Promjena teksta u 'x'
  } else {
    layerSwitcher.style.display = 'none'; // Sakrivanje Layer Switchera
    toggleButton.innerHTML = '&#8942;&#8942;&#8942;'; // Promjena teksta u '&#8942;&#8942;&#8942;'
  }
});

const printButton = document.getElementById('print');
const printSwitcher = document.getElementById('printSwitcher');

printButton.addEventListener('click', function() {
    if (printSwitcher.style.display === 'none') {
      printSwitcher.style.display = 'flex';
	  printButton.style.backgroundColor = '#007B66';
	  printArea.style.display = 'block';
	  var size = map.getSize();
	  if(size[0]>size[1]){
		dsize = size[1]
	  } else{
	  	dsize = size[0]
	  };
	  dsize = Math.round((Math.round(dsize/210))/2);
	  size = [dsize*297,dsize*210]
	  printArea.style.width = size[0] + 'px';
	  printArea.style.height = size[1] + 'px';
    } else {
      printSwitcher.style.display = 'none';
	  printButton.style.backgroundColor = 'white';
	  printArea.style.display = 'none';
    }
});

const closeiconprint = document.getElementById('closeicon-print');

closeiconprint.addEventListener('click', function() {
    if (printSwitcher.style.display === 'none') {
      printSwitcher.style.display = 'flex';
	  printButton.style.backgroundColor = '#007B66';
    } else {
      printSwitcher.style.display = 'none';
	  printButton.style.backgroundColor = 'white';
	  printArea.style.display = 'none';
    }
});

map.addControl(
  new Control({
    element: printButton,
  })
);

map.addControl(
  new Control({
    element: printSwitcher,
  })
);

let selectedFeature = null; // Referenca na trenutno odabrani vektorski element
let originalStyle = null; // Referenca na izvorni stil trenutno odabranog elementa
let previousSelectedFeature = null;

// Stil za označeni vektorski element
var selectedStyle = new Style({
  fill: new Fill({
    color: 'rgba(255, 0, 0, 0.5)'
  }),
  stroke: new Stroke({
    color: 'red',
    width: 2.5
  }),
});

map.on('click', function(evt) {
  if (crtanje || mjerenje) return;
  if(previousSelectedFeature){
		previousSelectedFeature.setStyle(null)
	};
  var feature = map.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {
    if (layer === vectorLayer3 || layer === vectorLayer4 || layer === vectorLayer5 || layer === vectorLayer6 || layer === vectorLayer7 || layer === vectorLayer8 || layer === vectorLayer9 || layer === vectorLayer10) {
	  return feature;
    }
  }, {
    hitTolerance: 8
  });
  
  if (selectedFeature && selectedFeature !== feature) {
    // Vratite izvorni stil prethodno odabranog elementa
    selectedFeature.setStyle(originalStyle);
  }
  
  if (feature) {
    selectedFeature = feature; // Spremite trenutno odabrani element
    originalStyle = feature.getStyle(); // Spremite izvorni stil trenutno odabranog elementa
    feature.setStyle(selectedStyle);

    var properties = feature.getProperties();
    var popupContent = '<h3>' + 'Atributna tablica' + '</h3>';

    // Iteracija kroz atribute i dodavanje njihovog imena i vrijednosti u popup
    for (var property in properties) {
      if (properties.hasOwnProperty(property)) {
        if (property !== 'geometry') {
          popupContent += '<p>' + property + ': ' + properties[property] + '</p>';
        }
      }
    }

    content.innerHTML = popupContent;
    container.style.display = 'block';
  } else {
    if (selectedFeature) {
      // Ako nema novog odabranog elementa, vrati izvorni stil prethodno odabranog elementa
      selectedFeature.setStyle(originalStyle);
	  container.style.display = 'none';
    }
    selectedFeature = null;
  }
});

closer.addEventListener('click', function() {
  if (selectedFeature) {
    selectedFeature.setStyle(originalStyle);
  }
  selectedFeature = null;
});

closer.addEventListener('click', function() {
    if (container.style.display === 'none') {
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
    }
});

map.addControl(
  new Control({
    element: container,
  })
);

// Kreiranje tražilice atributa
const searchSource = new VectorSource({
	features: []
});

vectorSource2.on("addfeature", function (e) {
  const feature = e.feature;
  feature.setStyle(null);
  searchSource.addFeature(e.feature);
});

vectorSource4.on("addfeature", function (e) {
  const feature = e.feature;
  feature.setStyle(null);
  searchSource.addFeature(e.feature);
});

vectorSource5.on("addfeature", function (e) {
  const feature = e.feature;
  feature.setStyle(null);
  searchSource.addFeature(e.feature);
});

vectorSource6.on("addfeature", function (e) {
  const feature = e.feature;
  feature.setStyle(null);
  searchSource.addFeature(e.feature);
});

vectorSource7.on("addfeature", function (e) {
  const feature = e.feature;
  feature.setStyle(null);
  searchSource.addFeature(e.feature);
});

vectorSource9.on("addfeature", function (e) {
  const feature = e.feature;
  feature.setStyle(null);
  searchSource.addFeature(e.feature);
});

const searchControl = new SearchFeature({
  source: searchSource,
  getTitle: function (feature){
        if (feature.get("NAZIV NASELJA")) {
            return feature.get("NAZIV NASELJA");
        }
        else if (feature.get("NAZIV JAVNE POVRŠINE")) {
            return feature.get("NAZIV JAVNE POVRŠINE");
        }
		else if (feature.get("OZNAKA I NAZIV NERAZVRSTANE CESTE")) {
            return feature.get("OZNAKA I NAZIV NERAZVRSTANE CESTE");
        }
		else if (feature.get("OZNAKA CESTE")) {
            return feature.get("OZNAKA CESTE");
        }
		else if (feature.get("NAZIV GROBLJA")) {
            return feature.get("NAZIV GROBLJA");
        }
		else if (feature.get("NAZIV AUTOBUSNE ČEKAONICE")) {
            return feature.get("NAZIV AUTOBUSNE ČEKAONICE");
        }
        // Ako niti jedan od atributa nije pronađen, vraćamo null
        return null;
    },
  placeholder: 'Pretraži',
});

searchControl.on('select', function (e) {
	container.style.display = 'none';
	var selectedFeature = e.search;
	var extent = selectedFeature.getGeometry().getExtent();
	selectedFeature.setStyle(selectedStyle);
	map.getView().fit(extent, {
    padding: [50, 50, 50, 50], // Dodajte prilagođeni okvir oko objekta
    duration: 1000, // Prilagodite trajanje animacije po želji
    maxZoom: 18 // Prilagodite maksimalnu razinu zumiranja po želji
  });
});

searchControl.on('select', function (e) {
  if (previousSelectedFeature) {
    previousSelectedFeature.setStyle(null); // Uklanjanje stila s prethodno označene značajke
  }
  var selectedFeature = e.search;
  selectedFeature.setStyle(selectedStyle); // Postavljanje stila na označenu značajku
  previousSelectedFeature = selectedFeature;
});

// Dodavanje tražilice u mapu
map.addControl(searchControl);

//dodavanje info prozora
const infoButton = document.getElementById('info');
const infoWindow = document.getElementById('info-window');

infoButton.addEventListener('click', function() {
    if (infoWindow.style.display === 'none') {
      infoWindow.style.display = 'block';
	  infoButton.style.backgroundColor = '#007B66';
    } else {
      infoWindow.style.display = 'none';
	  infoButton.style.backgroundColor = 'white';
    }
});

map.addControl(
  new Control({
    element: infoButton,
  })
);

map.addControl(
  new Control({
    element: infoWindow,
  })
);

//legenda
const legendaButton = document.getElementById('legenda');
const legendaWindow = document.getElementById('legenda-window');

legendaButton.addEventListener('click', function() {
    if (legendaWindow.style.display === 'none') {
      legendaWindow.style.display = 'block';
	  legendaButton.style.backgroundColor = '#007B66';
    } else {
      legendaWindow.style.display = 'none';
	  legendaButton.style.backgroundColor = 'white';
    }
});

const closeiconlegend = document.getElementById('closeicon-legenda');

closeiconlegend.addEventListener('click', function() {
    if (legendaWindow.style.display === 'none') {
      legendaWindow.style.display = 'block';
	  legendaButton.style.backgroundColor = '#007B66';
    } else {
      legendaWindow.style.display = 'none';
	  legendaButton.style.backgroundColor = 'white';
    }
});

map.addControl(
  new Control({
    element: legendaButton,
  })
);

map.addControl(
  new Control({
    element: legendaWindow,
  })
);